import React from "react";
import { Div, Anchor, Text } from "atomize";
import { Transition } from "react-transition-group";
import { OutboundLink } from "gatsby-plugin-google-gtag"
import { Link } from "gatsby"

const duration = 200;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};
const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

export default function MobileHeaderMenu({
  setMobileMenuOpen,
  mobileMenuOpen,
  navLinks,
}) {
  return (
    <Transition in={mobileMenuOpen} timeout={duration} unmountOnExit>
      {(state) => (
        <Div
          d={{ xs: "flex", lg: "none" }}
          p={{ t: "5.25rem" }}
          zIndex="-1"
          border={{ b: "1px solid" }}
          borderColor="light"
          h="336px"
          maxH="calc(100vh - 72px)"
          flexDir="column"
          justify="flex-end"
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {/* <Div className="blurred-bg" /> */}
          {navLinks.map((link, index) => {

            if (link.url) {
              return (
                <OutboundLink href={link.url} target="_blank" style={{ whiteSpace: "nowrap" }}>
                  <Anchor
                    key={`navlink-${index}`}
                    href={link.url}
                    target="_blank"
                    d="block"
                    p={{ xs: "1rem", sm: "1rem 3rem" }}
                    textSize="subtitle"
                    textColor={index === 3 ? "mint" : "white"}
                    hoverTextColor={index === 3 ? "mint" : "white"}
                    border={{ t: "1px solid" }}
                    borderColor="light"
                  >
                    {link.text}
                  </Anchor>
                </OutboundLink>
              )
            }

            if (link.internalUrl) {
              return (
                <Link to={link.internalUrl}>
                  <Text
                    key={`navlink-${index}`}
                    href={link.internalUrl}
                    d="block"
                    p={{ xs: "1rem", sm: "1rem 3rem" }}
                    textSize="subtitle"
                    textColor={index === 3 ? "mint" : "white"}
                    border={{ t: "1px solid" }}
                    borderColor="light"
                  >
                    {link.text}
                  </Text>
                </Link>
              )
            }

            return (
              <Anchor
                key={`mobile-navlink-${index}`}
                d="block"
                p={{ xs: "1rem", sm: "1rem 3rem" }}
                textSize="subtitle"
                textColor={index === 3 ? "mint" : "white"}
                hoverTextColor={index === 3 ? "mint" : "white"}
                border={{ t: "1px solid" }}
                borderColor="light"
                onClick={() => {
                  link?.onClick && link.onClick();
                  setMobileMenuOpen(false);
                }}
              >
                {link.text}
              </Anchor>
            );
          })}
        </Div>
      )}
    </Transition>
  );
}
